import _ from '@lodash';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { Button } from '@material-ui/core';
import { useState } from 'react';
import ComponentMassSomethingDialog from 'app/admin/common/component/ComponentMassSomethingDialog';
import AspectEditService from 'app/admin/aspect/service/AspectEditService';
import ModelService from 'app/admin/model/service/ModelService';

function AspectAnalysisField(props) {
	const methods = useFormContext();
	const { value, onChange } = props.field;

	const [fields, setFields] = useState(null);
	const [components, setComponents] = useState(null);

	const [openDialog, setOpenDialog] = useState(false);
	const { compact = false } = props;

	const handleOpen = () => {
		getAnalysisInfo();
		getFields();
		setOpenDialog(true);
	};

	const getAnalysisInfo = () => {
		props.fieldConfig.storageService.getAnalysisInfo(methods.getValues(), props.field).then(resp => {
			setComponents(resp);
		}).catch(e => console.log(e));
	};

	const getAttrList = (src, snakeKey, camelKey) => {
		if (!src) return [];
		const v = (src[snakeKey] != null) ? src[snakeKey] : src[camelKey];
		return Array.isArray(v) ? v : [];
	};

	const getFields = () => {
		const dto = methods.getValues();
		const m = String(props.fieldPrefix || '').match(/\d+/);
		const index = m ? parseInt(m[0], 10) : NaN;
		const lineData = (dto && Array.isArray(dto.fields) && Number.isFinite(index)) ? dto.fields[index] : null;

		if (!lineData || !dto?.aspect) {
			setFields([]);
			return;
		}

		const isOutput = String(lineData.category || '').toLowerCase() === 'output';
		const lineName = lineData?.name;

		if (!lineName) {
			setFields([]);
			return;
		}

		AspectEditService.getData(dto.aspect).then(aspectData => {
			if (!aspectData?.model) {
				setFields([]);
				return;
			}

			const aspectInputs = getAttrList(aspectData, 'input_attributes', 'inputAttributes');
			const aspectOutputs = getAttrList(aspectData, 'output_attributes', 'outputAttributes');
			const aspectPool = isOutput ? aspectOutputs : aspectInputs;

			const aspectAttr =
				aspectPool.find(a => a?.name === lineName) ||
				aspectInputs.find(a => a?.name === lineName) ||
				aspectOutputs.find(a => a?.name === lineName) ||
				null;

			const mappedModelFieldName =
				aspectAttr?.modelFieldName ??
				aspectAttr?.model_field_name ??
				null;

			const targetModelName = mappedModelFieldName || lineName;

			ModelService.getData(aspectData.model).then(modelData => {
				// ✅ "rich" listák (ezekben van value)
				const modelInputs = Array.isArray(modelData?.inputAttributes) ? modelData.inputAttributes : [];
				const modelOutputs = Array.isArray(modelData?.outputAttributes) ? modelData.outputAttributes : [];

				const primaryList = isOutput ? modelOutputs : modelInputs;
				const fallbackList = isOutput ? modelInputs : modelOutputs;

				const findByName = (list, name) => (Array.isArray(list) ? list : []).find(a => a?.name === name) || null;

				const modelAttr =
					findByName(primaryList, targetModelName) ||
					findByName(primaryList, lineName) ||
					findByName(fallbackList, targetModelName) ||
					findByName(fallbackList, lineName);

				const obj = modelAttr?.value;

				let _fields = [];
				if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
					for (let key in obj) _fields.push({ label: key, value: key });
				}

				setFields(_fields);
			}).catch(e => {
				console.log(e);
				setFields([]);
			});
		}).catch(e => {
			console.log(e);
			setFields([]);
		});
	};

	return (
		<div className={clsx(compact ? 'flex items-center px-8' : 'flex items-center px-8 mt-8 mb-16', props.fieldConfig.className)}>

			<Button variant="contained" color="primary" className="w-full" onClick={() => handleOpen()}>
				Open
			</Button>

			{openDialog && (
				<ComponentMassSomethingDialog
					fieldPrefix={props.fieldPrefix}
					disableCopyPaste
					value={value}
					keyKey='field'
					valueKey='component'
					keyItems={fields || []}
					valueItems={components || []}
					// keyItems={fields}
					// valueItems={components}
					type='SELECT_PAIRS'
					onCancel={() => setOpenDialog(false)}
					onSave={result => { onChange(result); setOpenDialog(false); }}
				/>
			)}

		</div>
	);
}

export default AspectAnalysisField;